import AlertSystem from "@/components/AlertSystem.vue";
import { Formatter } from "@/utils/currencyFormatter.js";
import { big_headers } from "@/shared/constants/big_headers.json"

// @ is an alias to /src
export default {
  name: 'Faturamento',
  components: {
    AlertSystem,
  },
  data() {
    return {
      headers: big_headers.src.views.Sebraetec.agrupar.headers.main,
      system:{
        snackbar: {}
      },
      loading: false,
      faturamentos: [],
      search: '',
      status: 1,
      unidadesList: [],
      unidadeSelecionada:null,
      snackbar: false,
      agrupar: null
    }
  },
  methods: {
    formatValue(value) {
      return Formatter(value)
    },
    getUnidades() {
      this.axios('unidades').then(res => {
        this.unidadesList = res.data
      })
    },
    getFaturamentos () {
        this.axios.get('/faturamentos', {
          params:{
            IdSituacao: null,
            IdUnidade: this.unidadeSelecionada,
            Sebraetec: 1
          }
        }).then( res => {
            this.faturamentos = res.data.filter(element => {
              element.RazaoSocial = this.prepareNameFilter(element.RazaoSocial);
              return element;
            })
        })
    },
    processarRetorno() {
      this.loading = true
      const lista = this.faturamentos.filter(arr => arr.NotaFiscalNumero === this.search)
      lista.length > 1 ? 
        this.axios.post('sebraetec', lista).then(res => {
          this.system.snackbar = {
            snackbar: true,
            text: res.data.message,
            color: "green",
          }
        }) : 
        this.system.snackbar = {
          snackbar: true,
          text: 'Só é possível agrupar duas ou mais faturas',
          color: "red",
        }
      this.loading = false
      this.getFaturamentos()
    },
    limparFiltros(){
      this.search = null
      this.unidadeSelecionada = null
      this.getFaturamentos();
    }
  },
  mounted() {
      this.getFaturamentos()
      this.getUnidades()
  }
}